// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import SmileOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/SmileOutlined';
import CrownOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CrownOutlined';
import TableOutlined from '/app/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
export default { SmileOutlined, CrownOutlined, TableOutlined };
